// API wrappers for per-brand multi-channel alert config (WhatsApp / Telegram /
// Discord / Slack / Teams). Backend mounted at /api/alert-channels. Secrets are
// never returned — the server sends hasAccessToken / hasBotToken / hasWebhookUrl
// flags instead. Thin pass-throughs to the shared fetch helpers in ../index.
import { post, get } from "../index";

const BASE = "/api/alert-channels";

// All channels for a brand, masked.
export const getAlertChannels = (brandSettingsId) =>
  get(`${BASE}/config?brandSettingsId=${encodeURIComponent(brandSettingsId)}`);

// Save ONE channel: { brandSettingsId, channel, ...fields }.
export const saveAlertChannel = (data) => post(`${BASE}/config`, data, false);

// Send a test through ONE channel: { brandSettingsId, channel, text? }.
export const testAlertChannel = (data) => post(`${BASE}/test`, data, false);
